import { render, staticRenderFns } from "./indexLayout.vue?vue&type=template&id=63b9ca84&"
import script from "./indexLayout.vue?vue&type=script&lang=js&"
export * from "./indexLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports